require('./bootstrap');


var navMenuDiv = document.getElementById('nav-content')
var navMenu = document.getElementById('nav-toggle')

document.onclick = check

function check (e) {
    var target = (e && e.target) || (event && event.srcElement)

    // actionToggle(userMenu, userMenuDiv, target, 'invisible') // <-- THis one Works

    actionToggle(navMenu, navMenuDiv, target, 'hidden') // This one does not!!!!!

}

function actionToggle (actionElm, contentElm, target, toggleClass) {
    if (!checkParent(target, contentElm)) {
        // click NOT on the menu
        if (checkParent(target, actionElm)) {
            // click on the link
            if (contentElm.classList.contains(toggleClass)) {
                contentElm.classList.remove(toggleClass)
            } else {contentElm.classList.add(toggleClass)}
        } else {
            // click both outside link and outside menu, hide menu
            contentElm.classList.add(toggleClass)
        }
    }
}

function checkParent (t, elm) {
    while (t.parentNode) {
        if (t == elm) {return true}
        t = t.parentNode
    }
    return false
}










import Vue from 'vue'
import { FvlForm, FvlInput, FvlMultiFile, FvlSelect, FvlSubmit, FvlTextarea } from 'formvuelar'

import scrollToAnchor from 'scroll-to-anchor'

const FORM_SELECTOR = '#quote-form'

const FORM = {
    name: '',
    phone: '',
    email: '',

    product: '',
    quantity: '',

    comments: '',
    files: [],
}

const app = new Vue({
    el: '#quote-form',
    components: {
        FvlForm,
        FvlSelect,
        FvlInput,
        FvlSubmit,
        FvlTextarea,
        FvlMultiFile
    },

    data () {

        return {
            formSuccess: false,
            successMessage: '',
            submitDisabled: false,
            form: FORM,
            option: {
                'Save The Date Magnets': 'Save The Date Magnets',
                'Business Card Magnets': 'Business Card Magnets',
                'Stock Rectangle Magnets': 'Stock Rectangle Magnets',
                'Stock Circle Magnets': 'Stock Circle Magnets',
                'Stock Shape Magnets': 'Stock Shape Magnets',
                'Calendar Magnets': 'Calendar Magnets',
                'Ribbon Magnets': 'Ribbon Magnets',
                'Button Magnets': 'Button Magnets',
                'Photo Frame Magnets': 'Photo Frame Magnets',
                'Auto Magnets': 'Auto Magnets',
                'Custom Hand Fans': 'Custom Hand Fans',
                'Custom Stickers': 'Custom Stickers',
            },
        }
    },
    methods: {
        onSuccess (e) {
            this.submitDisabled = false
            this.successMessage = e.data.message
            this.formSuccess = true
            scrollToAnchor(FORM_SELECTOR, { behavior: 'smooth', alignToTop: true })
        },
        onRequestStarted(){
            this.submitDisabled = true
        },

        onError (e) {
            console.log('[name=' + Object.keys(e.data.errors)[0] + ']');

            scrollToAnchor('[name=' + Object.keys(e.data.errors)[0] + ']', { behavior: 'smooth', alignToTop: true })
            this.submitDisabled = false
        }
    }
})
